export const getDaysOfTheWeek = content => [
  content.cpo_charger_details_monday,
  content.cpo_charger_details_tuesday,
  content.cpo_charger_details_wednesday,
  content.cpo_charger_details_thursday,
  content.cpo_charger_details_friday,
  content.cpo_charger_details_saturday,
  content.cpo_charger_details_sunday
]
